import css from "./badges.module.scss"
import {FC} from "react";
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface BadgeProps {
    icon: IconDefinition;
    title: string;
}
const Badge: FC<BadgeProps> = ({ icon, title }) => {
    return (
        <div className={css.container}>
            <FontAwesomeIcon icon={icon} className={css.icon}/>
            <span>{title}</span>
        </div>
    );
};

export default Badge;